import { useEffect, useState } from "react";
import { Button, Col, Form, Select, Table } from "antd";
import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import Upload from "antd/lib/upload/Upload";
import ContainerLayout from "../../common/containerLayout";
import {
  parseDataFromXMLSNotifyPassenger,
  parseDataFromXMLSNotifyPassengerContingency,
} from "./utils";
import Column from "antd/lib/table/Column";
import { CheckCircleOutlined } from "@ant-design/icons";
import {
  ContingencyNotificationType,
  NotificationType,
} from "./notificationType";
import { sendWhatsappToPassenger } from "../../../services/adminApi";
import { readUploadXLSXFile } from "../../groupTrip/common/utils";
import TemplateType from "../../../shared/enum/TemplateTypeEnum";

const NotifyPassengerExcel = () => {
  const [data, setData] = useState<Array<any>>([]);
  const [fileList, setFileList] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const templateType = Form.useWatch("templateType", form);

  const readUploadFile = (e: any) => {
    readUploadXLSXFile(
      e,
      (data) => {
        const list =
          templateType === TemplateType.STANDARD
            ? parseDataFromXMLSNotifyPassenger(data)
            : parseDataFromXMLSNotifyPassengerContingency(data);
        setData(list);
      },
      false,
    );
  };

  const normFile = (e: any) => {
    setLoading(true);
    if (e?.fileList && e?.fileList.length) {
      const tmp = { target: { files: [e?.file] } };
      setFileList(e?.file ? [e.file] : []);
      readUploadFile(tmp);
    } else {
      setFileList([]);
    }
    if (Array.isArray(e)) {
      return e;
    }
    setLoading(false);
    return e?.fileList;
  };

  const onFinish = async (values: any) => {
    setLoading(true);
    const { notificationTypeId } = values;
    if (!data || !notificationTypeId) return;

    await sendWhatsappToPassenger(data, notificationTypeId);
    setLoading(false);
    setData([]);
    setFileList([]);
  };

  const handleRemovedFile = (e: any) => {
    if (!e.fileList.length) {
      setData([]);
    }
  };

  useEffect(() => {
    setData([]);
    setFileList([]);
    form.setFieldValue("notificationTypeId", null);
  }, [form, templateType]);

  return (
    <ContainerLayout
      title="Notificar Pasajeros via Whatsapp"
      showNotification={false}
    >
      <Col span={24}>
        <Form
          layout="inline"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          disabled={loading}
          initialValues={{
            templateType: TemplateType.STANDARD,
          }}
        >
          <Form.Item
            name="upload"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            className="custom-upload-xlsx-file"
          >
            <Upload
              listType="picture"
              beforeUpload={() => false}
              maxCount={1}
              onChange={handleRemovedFile}
            >
              {!fileList.length && (
                <Button icon={<UploadOutlined />}>Cargar archivo excel</Button>
              )}
            </Upload>
          </Form.Item>
          <Form.Item
            name="notificationTypeId"
            label="Tipo de Notificacion"
            tooltip="
                  Que mensaje desea que se le envie al pasajero?

                  NOTA:
                  Si enviaras notificacion con booking id asegurate
                  que todos los usuarios tienen booking id de otra
                  forma no le llegara la notificacion al usuario sin
                  booking id. (Asi mismo como otros campos que son
                  importantes como Nombre, Teléfono, Fecha y Hora)
                "
            rules={[
              {
                required: true,
                message: "Por favor seleccione un tipo de notificacion!",
              },
            ]}
          >
            <Select
              placeholder="Seleccione un tipo de notificacion"
              options={
                templateType === TemplateType.STANDARD
                  ? NotificationType
                  : ContingencyNotificationType
              }
            />
          </Form.Item>
          <Form.Item name="templateType" label="Tipo de plantilla">
            <Select
              style={{ width: "10rem" }}
              placeholder="Seleccione un tipo de plantilla"
              options={[
                {
                  label: "Estándar",
                  value: TemplateType.STANDARD,
                },
                {
                  label: "Contingencia",
                  value: TemplateType.CONTINGENCY,
                },
              ]}
            />
          </Form.Item>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
            disabled={!data?.length}
            loading={loading}
            icon={<CheckCircleOutlined />}
          >
            Enviar notificacion
          </Button>
        </Form>
      </Col>
      <Col span={24} style={{ width: "100px", height: "83vh" }}>
        <Table
          dataSource={data}
          rowKey="id"
          scroll={{ y: "calc(-250px + 97vh)" }}
          loading={loading}
          pagination={{ hideOnSinglePage: true }}
        >
          <Column title="Nombre" width={150} dataIndex="name" />
          <Column title="Teléfono" width={150} dataIndex="phoneNumber" />
          {templateType === TemplateType.STANDARD && (
            <>
              <Column title="Fecha" width={150} dataIndex="date" />

              <Column title="Booking Id" width={150} dataIndex="bookingId" />
            </>
          )}
          <Column title="Hora" width={150} dataIndex="hour" />
          {templateType === TemplateType.CONTINGENCY && (
            <>
              <Column title="Origen" width={150} dataIndex="originAddress" />
              <Column
                title="Destino"
                width={150}
                dataIndex="destinationAddress"
              />
            </>
          )}
        </Table>
      </Col>
    </ContainerLayout>
  );
};

export default NotifyPassengerExcel;
